module.exports = __webpack_public_path__ + "img/file-upload.dc8bf226.svg";